import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCourses
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCoursesSelected = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url = module.courses?.length
    ? `/admin/courses?courseType=all&page=1&sortBy=queryIds` +
      `&limit=${module.courses.length}` +
      `&id=${module.courses.join(filterValuesSeparator)}`
    : '';

  return (
    <div>
      <HomePageSettingsTilesCourses
        includeActions={true}
        module={module}
        updateModule={updateModule}
        url={url}
      />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.commonSelectedCourses,
            value: module.courses?.length || 0
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          hideLimit={true}
          module={module}
          onUpdate={updateModule}
          productType="course"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCoursesSelected;
